import Vue from 'vue';

export default [
    {
        pathId: 'txm',
        component: 'transactions-menu',
        title: 'Transactions',
        icon: 'fa-usd-circle',
        size: 'sm'
    },
    {
        pathId: 'txl',
        component: 'transactions-list',
        title: 'Transactions',
        icon: 'fa-usd-circle',
        size: 'md',
        reload: true,
        loading: true,
        props: ['startDate', 'endDate', 'transactionTypes']
    },
    {
        pathId: 'txd',
        component: 'transaction-detail',
        title: 'Transaction',
        icon: 'fa-usd-circle',
        size: 'md',
        loading: true,
        props: ['transactionId']
    }
];

Vue.component('transactions-menu', () => import('@/cards/transactions/TransactionsMenu'));
Vue.component('transactions-list', () => import('@/cards/transactions/TransactionsList'));
Vue.component('transaction-detail', () => import('@/cards/transactions/TransactionDetail'));
